// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"image-thumbnail-module--imageContainer--KVnhq","image":"image-thumbnail-module--image--2XmqV"};